import { createContext, Dispatch, SetStateAction } from 'react';

import { FileX } from '~src/types/upload';

export interface UploadCtx {
  uploadContext: FileX[];
  setUploadContext: Dispatch<SetStateAction<UploadCtx['uploadContext']>>;
}

// UplaodedContext is holds all the files that
// will be uploaded
const UploadContext = createContext({
  uploadContext: [],
  setUploadContext: () => [],
} as UploadCtx);

export default UploadContext;
